// extracted by mini-css-extract-plugin
module.exports = {"contain":"Paginado_contain__4JIZy","active":"Paginado_active__xEVV2"};